import { withCurrentParams } from 'actions/utils';
import { BROADCAST_UPDATE_OVERLAY_POSITION } from 'actions/Types';

export default overlayId => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_UPDATE_OVERLAY_POSITION,
      request: async apiClient => {
        const broadcast = await apiClient.broadcast.get(
          teamId,
          eventId,
          broadcastId
        );

        const { overlays } = broadcast;
        const updatedOverlay = overlays.find(
          overlay => overlay._id === overlayId
        );
        return updatedOverlay;
      }
    };
    dispatch(action);
  });
};
